import React from 'react'
import { ButtonGroup, Button } from 'react-bootstrap'

const AdminTabs = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <ButtonGroup className="mb-3 shadow-sm rounded-start rounded-end">
      {tabs.map((tab) => (
        <Button
          key={tab.value}
          variant="light"
          onClick={() => setActiveTab(tab.value)}
          className={`py-1.5 px-3 ${
            activeTab === tab.value ? 'admin-tabs-active' : 'bg-white'
          }`}
        >
          {tab.name}
        </Button>
      ))}
    </ButtonGroup>
  )
}

export default AdminTabs
